import { Pagination, Table, Tag } from "antd";

function DevicesTable(props: any) {
  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      render: (_: any, __: any, rowIndex: number) => {
        return <div className="table-Txt">{rowIndex}</div>;
      },
    },
    {
      title: "Device Id",
      dataIndex: "device",
      key: "device",
      render: (record: any) => {
        return <div className="table-Txt">{record?.deviceId}</div>;
      },
    },
    {
      title: "Device Type",
      dataIndex: "device",
      key: "device",
      render: (record: any) => {
        return <div className="table-Txt">{record?.deviceType}</div>;
      },
    },
    {
      title: "Device Name",
      dataIndex: "device",
      key: "device",
      render: (record: any) => {
        console.log("=record===",record)
        return <div className="table-Txt">{record?.deviceName}</div>;
      },
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: () => (
        <div className="table-Action">
            <Tag color="green">True</Tag>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div>
        <Table
          columns={columns}
          dataSource={props?.data}
          pagination={false}
          size="small"
        />
        <br />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Pagination
            total={props?.meta?.total_count}
            showSizeChanger
            showTotal={(total) => `Total ${props?.meta?.total_count} Staffs`}
            onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
          />
        </div>
      </div>
    </div>
  );
}
export default DevicesTable;
